import { api } from '@/api';
import { queryClient } from '@/queries';
import { driveServiceTripsQueryKeys } from './drive-service.keys';

export const getGroundTripsList = async (groundTripIds: string[]) => {
  const res = await api.driveService.getLogisticsGroundTrips({
    groundTripIds: groundTripIds.join(','),
  });

  res.items.forEach((item) => {
    queryClient.setQueryData(driveServiceTripsQueryKeys.getItem(item.id), item);
  });

  return res;
};
